/**
 * Supported social media platforms
 */
export type SocialPlatform = 'youtube' | 'tiktok' | 'instagram'

export const platformsConfig: Record<
  SocialPlatform,
  {
    id: SocialPlatform
    name: string
    formatName: string
    icon: string
    url: string
  }
> = {
  youtube: {
    id: 'youtube',
    name: 'YouTube',
    formatName: 'YouTube Shorts',
    icon: '/icons/brands/youtube.svg',
    url: 'https://www.youtube.com',
  },
  tiktok: {
    id: 'tiktok',
    name: 'TikTok',
    formatName: 'TikTok Videos',
    icon: '/icons/brands/tiktok.svg',
    url: 'https://www.tiktok.com',
  },
  instagram: {
    id: 'instagram',
    name: 'Instagram',
    formatName: 'Instagram Reels',
    icon: '/icons/brands/instagram.svg',
    url: 'https://www.instagram.com',
  },
} as const

export type TPlatformsConfig = typeof platformsConfig
